export const FETCH_APPCONFIG_REQUEST = 'FETCH_APPCONFIG_REQUEST'
export const FETCH_APPCONFIG_SUCCESS = 'FETCH_APPCONFIG_SUCCESS'
export const FETCH_APPCONFIG_FAILURE = 'FETCH_APPCONFIG_FAILURE'
